<script lang="ts" setup></script>

<template>
  <div>
    <slot />
  </div>
</template>

<style scoped></style>